/* Navratri Picks — a few marigold / rose petals drifting down the page.
   Gentle, steady fall; off for reduced motion, paused when the tab is hidden. */
(function () {
  'use strict';
  var box = document.querySelector('[data-nv-petals]');
  if (!box || box.dataset.ready) return;
  box.dataset.ready = '1';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var colours = ['#f39c12', '#f6c453', '#e2862b', '#f48fb1', '#e57373', '#ffd54f'];
  var count = calm ? 8 : window.innerWidth < 750 ? 14 : 22;
  for (var i = 0; i < count; i++) {
    var p = document.createElement('span');
    p.className = 'nv-petal';
    var size = 9 + Math.round(Math.random() * 8);
    p.style.cssText =
      'left:' + (4 + Math.random() * 92).toFixed(1) + '%;' +
      '--s:' + size + 'px;' +
      '--c:' + colours[i % colours.length] + ';' +
      '--t:' + ((calm ? 12 : 8) + Math.random() * 4).toFixed(1) + 's;' +
      '--d:-' + (Math.random() * 12).toFixed(1) + 's;' +
      '--dx:' + Math.round(20 + Math.random() * 40) * (Math.random() < 0.5 ? -1 : 1) + 'px;';
    box.appendChild(p);
  }

  document.addEventListener('visibilitychange', function () {
    box.style.display = document.hidden ? 'none' : '';
  });
})();
